// 方法
import dayjs from 'dayjs';
import { filterObjEmptyValue, filterStrSpace } from "../../utils/utils";
// 常量
import { IOptionalFormItems } from "../interface";
import { SuperFormItemProps } from "../../SuperForm/interface";
import { DEFAULT_DATA_FORMAT, DETAULT_TIME_FORMAT } from "../../constants/constant";

/**
 * 生成选中区域表单的值
 * @param contentFormItems 内容区域表单配置
 * @param contentValues 内容区域表单值
 */
export function getOptionalValues(contentFormItems?: IOptionalFormItems[], contentValues?: any) {
  if (contentValues && Array.isArray(contentFormItems) && contentFormItems.length) {
    const contentMap: Map<string, string> = new Map<string, string>();
    const defaultValues: string[] = [];
    contentFormItems.forEach(group => {
      const { value, children } = group;
      if (Array.isArray(children) && children.length) {
        children.forEach(item => {
          const { name, defaultChecked, } = item;
          contentMap.set(name as string, value);
          if (defaultChecked) {
            defaultValues.push(name);
          }
        });
      }
    });
    const optionalValues: any = {};
    const contentKeys = Object.keys(contentValues);
    defaultValues.forEach(item => {
      if (!contentKeys.includes(item)) {
        contentKeys.push(item);
      }
    });
    for (let key of contentKeys) {
      if (contentMap.has(key)) {
        const groupName = contentMap.get(key);
        if (groupName) {
          if (!optionalValues[groupName]) optionalValues[groupName] = [];
          optionalValues[groupName].push(key);
        }
      }
    }
    return optionalValues;
  }
}

// 处理表单值
export function formatFormData(values: any, formItems: SuperFormItemProps[]) {
  const searchValues = filterObjEmptyValue(values);
  const dataFiledInfo = getDataFiledInfo(formItems);
  for (let [key, value] of Object.entries(values)) {
    if (typeof value === 'string') {
      searchValues[key] = filterStrSpace(value, 'both');
    }
    if (dataFiledInfo[key]) {
      if (Array.isArray(value)) {
        searchValues[key] = value.map(v => {
          if (dayjs.isDayjs(v)) return v.format(dataFiledInfo[key]);
          return v;
        });
      }
      if (dayjs.isDayjs(value)) {
        searchValues[key] = value.format(dataFiledInfo[key]);
      }
    }
  }
  return searchValues;
};

/** 获取表单字段和格式化类型字符串 */
function getDataFiledInfo(formItems: SuperFormItemProps[]) {
  let dataFiledInfo: any = {};
  formItems.forEach(item => {
    const { formItemType, name, datePickerProps, timePickerProps, rangePickerProps, children } = item;
    if (formItemType === 'DatePicker' && typeof name === 'string') {
      dataFiledInfo[name] = datePickerProps?.format || DEFAULT_DATA_FORMAT;
    }
    if (formItemType === 'TimePicker' && typeof name === 'string') {
      dataFiledInfo[name] = timePickerProps?.format || DETAULT_TIME_FORMAT;
    }
    if (formItemType === 'RangePicker' && typeof name === 'string') {
      dataFiledInfo[name] = rangePickerProps?.format || DEFAULT_DATA_FORMAT;
    }
    if (formItemType === 'Group' && Array.isArray(children)) {
      dataFiledInfo = { ...dataFiledInfo, ...(getDataFiledInfo(children))}
    }
  });
  return dataFiledInfo;
}